// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__OQWR3","selects":"Documents_selects__qBYub"};